import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import {
  selectVehicles,
  selectVehiclesVisibleToUser,
} from "../../../ducks/data/trailers/selectors";
import { TrailerHover } from "./trailer-hover";
import { useTranslation } from "react-i18next";
import "./trailer-list-autocomplete.scss";
import { preventClickPropagation } from "../../../helpers/prevent-click-propagation";
import { useFeature } from "../../../hooks";

export const VehicleListAutocomplete = (props: {
  handleTrailerChange: (event: { id: string } | null) => void;
  routeTrailerId: string | null;
  isCompact?: boolean;
  type: "truck" | "trailer";
}) => {
  const { handleTrailerChange, routeTrailerId, isCompact, type } = props;
  const { t } = useTranslation("dispatching");
  const liteVersion = useFeature("lite-version");

  const vehicles = useSelector(selectVehicles);
  const visibleVehicles = useSelector(selectVehiclesVisibleToUser);

  const allVehiclesAsOptions = vehicles.map((trailer) => ({
    id: trailer.id,
    label: trailer.alias || trailer.number,
    alias: trailer.alias,
    number: trailer.number,
  }));
  const options = visibleVehicles
    .filter((v) => (type === "truck" ? v.powered : !v.powered))
    .map((trailer) => ({
      id: trailer.id,
      label: trailer.alias || trailer.number,
      alias: trailer.alias,
      number: trailer.number,
    }))
    .sort((a, b) => {
      if (a.alias && b.alias) return a.alias.localeCompare(b.alias);
      if (a.alias) return -1;
      if (b.alias) return 1;
      return a.number.localeCompare(b.number);
    });
  const value =
    allVehiclesAsOptions.find((x) => x.id === routeTrailerId) || null;

  return (
    <Autocomplete
      {...(liteVersion ? { fullWidth: true } : {})}
      value={value}
      onChange={(event, newValue) => {
        preventClickPropagation(event);
        handleTrailerChange(newValue);
      }}
      // getOptionLabel={(option) =>
      //   isCompact
      //     ? option.label
      //     : (type === "truck" ? t("truck") : t("trailer")) + ": " + option.label
      // }
      renderOption={({ key, ...props }, option) => (
        <li key={key} {...props}>
          <div>
            <div>{option.label}</div>
            {option.alias && (
              <div className="trailer-list-autocomplete__option-number-subtext">
                {option.number}
              </div>
            )}
          </div>
        </li>
      )}
      options={options}
      filterOptions={(options, params) => {
        return options.filter((option) => {
          const lowerCaseInput = params.inputValue.toLowerCase();
          return (
            option.label.toLowerCase().includes(lowerCaseInput) ||
            option.number.toLowerCase().includes(lowerCaseInput)
          );
        });
      }}
      forcePopupIcon={false}
      selectOnFocus
      handleHomeEndKeys
      sx={liteVersion ? {} : { width: 180 }}
      renderInput={(params) => (
        <TrailerHover trailerId={routeTrailerId} isCompact={isCompact}>
          <TextField
            {...params}
            sx={{
              ...(liteVersion ? { background: "white" } : {}),
              ...(isCompact ? { width: 120 } : {}),
            }}
            onClick={preventClickPropagation}
            placeholder={
              type === "truck"
                ? t("routeCard.selectTruck")
                : t("routeCard.selectTrailer")
            }
            variant={liteVersion ? "outlined" : "standard"}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
          />
        </TrailerHover>
      )}
    />
  );
};

export default VehicleListAutocomplete;
